import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn, Section } from './Section';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el ebook después de comprar?',
  a: 'Inmediatamente después de confirmar el pago recibís un email con el enlace de acceso. En menos de 5 minutos ya estás adentro.'
}, {
  q: '¿Sirve si nunca vendí nada ni tengo experiencia online?',
  a: 'Sí, especialmente para vos. Mujer Expansiva está diseñado para empezar desde cero. No necesitás haber vendido antes, tener un negocio armado ni entender de marketing.'
}, {
  q: '¿Necesito tener muchos seguidores para aplicarlo?',
  a: 'No. La Parte II te muestra exactamente cómo conseguir tus primeras clientas sin audiencia, sin publicidad paga y usando los canales que ya tenés.'
}, {
  q: '¿Los 5 bonos están incluidos en las dos opciones?',
  a: 'Sí. Los 5 bonos están incluidos en ambas opciones sin costo adicional. La diferencia del Premium es el acompañamiento: plantillas, sesión en vivo, soporte por voz y plan personalizado.'
}, {
  q: '¿Funciona para cualquier habilidad?',
  a: 'Sí. Diseño, cocina, idiomas, coaching, escritura, estética, fotografía, tejido, fitness, lo que sea. Si es una habilidad que alguien valora, se puede monetizar.'
}, {
  q: '¿En cuánto tiempo veo resultados reales?',
  a: 'El método está diseñado para que tengas tu oferta definida y tu precio puesto en la primera semana, y tu primera clienta o primera venta en los primeros 30 días.'
}, {
  q: '¿Qué diferencia tiene con videos gratis de YouTube?',
  a: 'Los videos de YouTube te dan piezas sueltas. Mujer Expansiva te da un sistema completo, con orden, con ejercicios aplicables y con el trabajo de mentalidad que los videos gratuitos nunca tocan.'
}, {
  q: '¿Por qué elegir Premium y no la opción estándar?',
  a: 'Si querés el resultado más rápido y con acompañamiento real, Premium es para vos. El plan personalizado y el soporte por voz te permiten avanzar sin quedarte trabada — algo que ningún ebook puede darte solo.'
}, {
  q: '¿La garantía es real?',
  a: 'Completamente real. 7 días, devolución del 100%, sin preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section bg="cream-dark" data-id="element-64">
      <FadeIn className="text-center mb-10 md:mb-16" data-id="element-65">
        <h2 className="font-serif text-3xl md:text-5xl text-plum" data-id="element-66">
          Preguntas Frecuentes
        </h2>
      </FadeIn>

      <div className="max-w-3xl mx-auto space-y-3 md:space-y-4" data-id="element-67">
        {faqs.map((faq, i) => <FadeIn key={i} delay={i * 0.05} data-id="element-68">
            <div className="bg-cream border border-plum/10 rounded-sm overflow-hidden" data-id="element-69">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-4 py-4 md:px-6 md:py-5 text-left flex justify-between items-center hover:bg-plum/[0.02] transition-colors" data-id="element-70">
                <span className="font-bold text-sm md:text-base text-plum pr-4 md:pr-8" data-id="element-71">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`text-gold flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} size={18} className="md:w-5 md:h-5" data-id="element-72" />
              </button>

              <AnimatePresence data-id="element-73">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-74">
                    <div className="px-4 pb-4 pt-1 md:px-6 md:pb-6 md:pt-2 text-sm md:text-base text-plum/70 leading-relaxed border-t border-plum/5" data-id="element-75">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
}